<template>
  <div class="widget-repair-card animate-pulse rounded-custom border border-gray-200 bg-transparent transition-all">
    <div class="flex items-center justify-between border-b border-gray-200 p-4">
      <div class="flex items-center gap-2">
        <div class="h-6 w-6 rounded-full bg-gray-300"></div>
        <div class="h-6 w-32 rounded bg-gray-300"></div>
      </div>
      <div class="h-8 w-16 rounded bg-gray-300"></div>
    </div>

    <div class="flex justify-around border-b border-gray-200 p-4">
      <!-- <div class="flex flex-col items-center">
        <div class="h-12 w-12 rounded-full bg-gray-300 p-3"></div>
        <div class="mt-1 h-4 w-28 rounded bg-gray-300"></div>
      </div> -->
      <div class="flex flex-col items-center">
        <div class="h-12 w-12 rounded-full bg-gray-300 p-3"></div>
        <div class="mt-1 h-4 w-28 rounded bg-gray-300"></div>
      </div>
    </div>

    <div class="body1 flex flex-col gap-2 p-4 text-fontPrimary">
      <!-- <div class="flex">
        <span class="min-w-[5rem] font-bold">
          <div class="h-4 w-12 rounded bg-gray-300"></div>
        </span>
        <span class="flex-1">
          <div class="h-4 w-full rounded bg-gray-300"></div>
        </span>
      </div> -->

      <div class="flex">
        <span class="min-w-[5rem] font-bold">
          <div class="h-4 w-12 rounded bg-gray-300"></div>
        </span>
        <span class="flex-1">
          <div class="h-4 w-full rounded bg-gray-300"></div>
        </span>
      </div>

      <div class="flex">
        <span class="min-w-[5rem] font-bold">
          <div class="h-4 w-12 rounded bg-gray-300"></div>
        </span>
        <span class="flex-1">
          <div class="h-4 w-full rounded bg-gray-300"></div>
        </span>
      </div>

      <div class="flex">
        <span class="min-w-[5rem] font-bold">
          <div class="h-4 w-12 rounded bg-gray-300"></div>
        </span>
        <div class="flex flex-wrap gap-2">
          <div class="h-4 w-16 rounded bg-gray-300"></div>
          <div class="h-4 w-16 rounded bg-gray-300"></div>
        </div>
      </div>
    </div>
  </div>
</template>
